import { render, staticRenderFns } from "./ProgressWizard.vue?vue&type=template&id=896fac02"
import script from "./ProgressWizard.vue?vue&type=script&lang=js"
export * from "./ProgressWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports